import { AxiosError } from 'axios';

import { axiosForHybris } from '@telialt/utils/src/axios/axiosForHybris';
import { withParams } from '@telialt/utils/src/helpers';
import { TeliaSegment } from '@telialt/utils/src/segment';

import { API } from './constants';
import { LeadSubmitData, LeadSubmitResponse } from './model';

export const apiPostLead = async (segment: TeliaSegment, leadData: LeadSubmitData) => {
    const response = await axiosForHybris.post<LeadSubmitResponse>(
        withParams(API.URL_LEAD_SUBMIT, { segment }),
        leadData,
    );

    if (response?.data?.data === 'error') {
        throw new AxiosError('Lead submission failed', undefined, response.config, response.request, response);
    }

    return response;
};
